import "../../assets/css/SideNavBar.css";

import { UserOutlined, FontColorsOutlined, ToolOutlined, SwapOutlined, MailOutlined, DeleteOutlined } from "@ant-design/icons";
import { Layout, Menu, Typography } from "antd";
import { useMemo } from "react";

import { adminToolCanUseGdprAccountDeletion } from "../../AdminConstants";
import useAuth from "../../hooks/useAuth";

const { Sider } = Layout;
const { Text } = Typography;

function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label: <Text ellipsis={{ tooltip: true }} className="hs-color-white ">{label}</Text>,
    title: label,
  };
}

export default function LeftPanel() {
  const { setCurrentSideTab, adminToolAccountUserRole } = useAuth();

  const items = useMemo(() => {
    const baseItems = [
      getItem("Customers", "customers", <UserOutlined />),
      getItem("Admins", "agents", <FontColorsOutlined />),
      getItem("Tools", "tools", <ToolOutlined />),
      getItem("Migration", "migration", <SwapOutlined />),
      getItem("RC Subscription", "rc_subscription", <MailOutlined />),
      getItem("Account deletion monitor", "account_deletion_monitor", <DeleteOutlined />),
    ];
    if (adminToolCanUseGdprAccountDeletion(adminToolAccountUserRole)) {
      baseItems.push(
        getItem("GDPR account deletion", "account_deletion_action", <DeleteOutlined />),
      );
    }
    return baseItems;
  }, [adminToolAccountUserRole]);

  const menuStyle = {
    marginLeft: "auto",
    marginRight: "auto",
    width: "99%",
    fontSize: "1rem",
    outerHeight: "100vh !important",
  };

  const menuSelectHandler = (item) => {
    setCurrentSideTab(item.key);
  };

  return (
    <>
      <Sider collapsed={false} collapsedWidth="0" theme="dark" width={180} className="mainSideNavBar">
        <div style={{ height: "71px", width: "127px" }}>
          <img
            style={{ width: "inherit" }}
            className="ms-4 my-3"
            src={require("../../assets/images/admin_tool_logo.png")}
            alt="admin tool logo"
          />
        </div>
        <Menu
          tabIndex={-1}
          onSelect={menuSelectHandler}
          style={menuStyle}
          theme="dark"
          defaultSelectedKeys={["customers"]}
          mode="inline"
          items={items}
        />
      </Sider>
    </>
  );
}
